<template>
  <div class="app ma-4">
    <v-row justify="space-around">
      <CardAverage cardTitle="TMC" :cardTime="operador.mediaTempoDeChamada" tip="Tempo Médio de Chamada" />
      <CardAverage cardTitle="TMA" :cardTime="operador.mediaTempoDeAtendimento" tip="Tempo Médio de Atendimento" />
      <CardAverage cardTitle="TME" :cardTime="operador.mediaEspera" tip="Tempo Médio de Espera" />
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="7" class="mt-4">
        <CardsResumoOperador :atendidas="operador.atendidas" :naoAtendidas="operador.naoAtendidas" />
      </v-col>
      <v-col cols="4">
        <DonutChart :valores="[Number(operador.atendidas), Number(operador.naoAtendidas)]" />
      </v-col>
    </v-row>

    <v-divider class="mx-2" />

    <LineChartMediaLigacoes
      :dataAtendidas="atualizaDataAtendidas(operador.datasMediaPorDia)"
      :dataNaoAtendidas="atualizaDataNaoAtendidas(operador.datasMediaPorDia)"
      :dataCategories="{
        dataCategory: atualizaEixoXGrafico(operador.datasMediaPorDia),
        title: 'Ligações por Dia',
      }"
    />

    <LineChartTempoMedioLigacoes
      :dataTmc="atualizaDataTmc(operador.datasMediaPorDia)"
      :dataTma="atualizaDataTma(operador.datasMediaPorDia)"
      :dataTme="atualizaDataTme(operador.datasMediaPorDia)"
      :dataCategories="{
        dataCategory: atualizaEixoXGrafico(operador.datasMediaPorDia),
        title: 'Tempos de Atendimento por Dia',
      }"
    />

    <LineChartMediaLigacoes
      :dataAtendidas="atualizaDataAtendidas(operador.datasMediaPorHora)"
      :dataNaoAtendidas="atualizaDataNaoAtendidas(operador.datasMediaPorHora)"
      :dataCategories="{
        dataCategory: atualizaEixoXGrafico(operador.datasMediaPorHora),
        title: 'Ligações por Hora',
      }"
    />

    <LineChartTempoMedioLigacoes
      :dataTmc="atualizaDataTmc(operador.datasMediaPorHora)"
      :dataTma="atualizaDataTma(operador.datasMediaPorHora)"
      :dataTme="atualizaDataTme(operador.datasMediaPorHora)"
      :dataCategories="{
        dataCategory: atualizaEixoXGrafico(operador.datasMediaPorHora),
        title: 'Tempos de Atendimento por Hora',
      }"
    />

    <TableCallsPorHora :dadosTabela="preencheTabelaLigacoesPorHora(operador.datasPorHora)" title="Ligações por Hora" />

    <TableCallsPorDia
      :dadosTabela="preencheTabelaLigacoesPorDia(operador.datasMediaPorDiaCorridos)"
      title="Ligações por Dia"
    />
  </div>
</template>

<script>
import CardAverage from '../../../../components/CardAverage'
import TableCallsPorHora from '../../../../components/TableCallsPorHora'
import TableCallsPorDia from '../../../../components/TableCallsPorDia'

import { graficosRelatoriosOperadorMethods } from '../../_methods/graficosRelatoriosOperadorMethods'
import { tabelasRelatoriosOperadorMethods } from '../../_methods/tabelasRelatoriosOperadorMethods'

import CardsResumoOperador from './CardsResumoOperador'
import DonutChart from './DonutChart'
import LineChartMediaLigacoes from './LineChartMediaLigacoes'
import LineChartTempoMedioLigacoes from './LineChartTempoMedioLigacoes'

export default {
  name: 'LayoutRelatorioResumido',
  props: {
    operador: Object,
  },
  components: {
    CardAverage,
    CardsResumoOperador,
    DonutChart,
    TableCallsPorHora,
    LineChartMediaLigacoes,
    LineChartTempoMedioLigacoes,
    TableCallsPorDia,
  },
  methods: {
    ...graficosRelatoriosOperadorMethods,
    ...tabelasRelatoriosOperadorMethods,
  },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
